var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge font-sub2",class:[{ small: _vm.count <= 9}, _vm.position, _vm.type]},[_c('span',{staticClass:"badge-number"},[_vm._v(_vm._s(_vm.count > 9 ? '9+' : _vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }